// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FncAnalysis_wrapper__36Zng"};